import useDeviceStore from "../useDeviceStore";

const getDeviceStore = () => useDeviceStore.getState();
export default getDeviceStore;
